module.exports = __webpack_public_path__ + "static/media/doutorCheckUp.85c9ab72.svg";